<div class="row">
  <div class="col-md-12 col-lg-4 mb-4" *ngFor="let additionalSectionCard of additionalSectionCards">
    <!-- <a [href]="additionalSectionCard.url" [target]="additionalSectionCard.buttonText === 'new' ? '_blank' : ''"> -->
    <div class="image-title-card">
      <div class="card lift">
        <div class="image-tile-container">
          <div class="outer-tile">
            <div class="image-tile show-image" style="background-image: url('{{ additionalSectionCard.headImage }}');"></div>
          </div>
        </div>

        <div class="card-body min-80">
          <i class="{{ additionalSectionCard.headIconClass }}"> </i>
          <h5>{{ additionalSectionCard.title }}</h5>
          <p>{{ additionalSectionCard.body }}</p>
          <div class="button-center">
            <a class="btn btn-primary" *ngIf="additionalSectionCard.buttonUrl || additionalSectionCard.buttonText" [href]="additionalSectionCard.buttonUrl" role="button" target="_blank">
              {{ additionalSectionCard.buttonText }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- </a> -->
  </div>
</div>
